module.exports = __webpack_public_path__ + "static/media/data.a9a6e7fd.svg";